<template>
    <div>
        <b-overlay :show="loading" no-wrap rounded></b-overlay>
        <section v-if="items.length>0">
            <h3>Transport services:</h3>
            <b-table  small stacked="sm" striped hover  :fields="modelColumns" :items="items" :show-empty="true"  :empty-text="'No se ha realizado ningun pago a esta reservación'">
                <template #cell(bookingPriceTotal)="row">
                {{$root.formatLblPrice(row.item.bookingPriceTotal,row.item.bookingCurrency)}}
                </template>
                <template #cell(paymentStatus)="row">
                    {{$root.getItemFromAuxVarOpts("transportServicePaymentStatusOpts",row.item.paymentStatus).text}}
                </template>
            </b-table>
        </section>

        <section v-if="itemsExtra.length>0">
            <h3>Servicios Adicionales:</h3>
            <b-table  small stacked="sm" striped hover  :fields="modelColumnsExtra" :items="itemsExtra" :show-empty="true"  :empty-text="'No se ha realizado ningun pago a esta reservación'">
                <template #cell(bookingPriceTotal)="row">
                {{$root.formatLblPrice(row.item.bookingPriceTotal,row.item.bookingCurrency)}}
                </template>
                <template #cell(paymentStatus)="row">
                    {{$root.getItemFromAuxVarOpts("transportServicePaymentStatusOpts",row.item.paymentStatus).text}}
                </template>
            </b-table>
        </section>
        
    </div>
</template>

<script>
    export default {
        props: {
            payment: {
                type : Object,
                required: true,
            }
        },
        data(){
            return {
                data:[],
                loading:false,
                modelColumns : [
                    {label:"Numero de servicio",key:"serviceNumber"},
                    {label:"Status pago",key:"paymentStatus"},
                    {label:"Canal de venta",key:"salesChannel.name"},
                    {label:"Tipo viaje",key:"trip"},
                    {label:"Total",key:"bookingPriceTotal"}
                ],
                modelColumnsExtra : [
                    {label:"Numero de servicio",key:"id"},
                    {label:"Servicio",key:"additionalServiceType.name"},
                    {label:"Status pago",key:"paymentStatus"},
                    {label:"Total",key:"bookingPriceTotal"}
                ],
            }
        },
        methods:{
          
        },
        mounted:function(){
           
        },
        computed:{
            items(){
                return [...this.payment.transportServices]
            },
            itemsExtra(){
                return [...this.payment.additionalServices??[]]
            }
            
         
        },




    }
</script>
